import gql from 'graphql-tag';
const MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT = gql `
  fragment MrsNewsSyllablesActivityFragment on MrsNewsSyllablesActivity {
    rounds {
      formattedText {
        formattingTool
        text
      }
      instructions
      partOfSpeech
      steps {
        answer
        stepType
      }
      word
    }
  }
`;
export default MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT;
